(() => {
  const SIZE_NAMES = ['size','men','women','tee'];
  const isSizeName = (name='') => SIZE_NAMES.includes(name.trim().toLowerCase());
  const hasVariantLink = () => new URLSearchParams(location.search).has('variant');

  function sizeControls(root=document) {
    const radios = [...root.querySelectorAll('variant-radios input[type="radio"]')].filter(i => isSizeName(i.name));
    const selects = [...root.querySelectorAll('variant-selects select')].filter(s => {
      const m=(s.name||'').match(/^options\[(.*)\]$/); return m && isSizeName(m[1]);
    });
    return {radios,selects};
  }

  function clearDefault(root=document) {
    if (hasVariantLink()) return;
    const {radios,selects}=sizeControls(root);
    radios.forEach(i=>i.checked=false);
    selects.forEach(s=>{
      if (!s.querySelector('option[value=""]')) {
        const o=document.createElement('option'); o.value=''; o.textContent='Select Size'; o.disabled=true; o.selected=true; s.prepend(o);
      }
      s.value='';
    });
  }

  function selected(root) {
    const {radios,selects}=sizeControls(root);
    if (!radios.length && !selects.length) return true;
    const radioGroups=[...new Set(radios.map(i=>i.name))];
    const radiosOk=radioGroups.every(n=>radios.some(i=>i.name===n&&i.checked));
    const selectsOk=selects.every(s=>!!s.value);
    return radiosOk && selectsOk;
  }

  function showMessage(form) {
    let msg=form.querySelector('.hm-select-size-message');
    if(!msg){msg=document.createElement('div');msg.className='hm-select-size-message';msg.setAttribute('role','alert');msg.style.cssText='margin:10px 0;color:#b00020;font-size:14px;font-weight:600;';msg.textContent='Please select a size';const b=form.querySelector('.product-form__buttons');(b||form).prepend(msg);}
    msg.scrollIntoView({behavior:'smooth',block:'center'});
  }

  document.addEventListener('DOMContentLoaded',()=>clearDefault(document));
  document.addEventListener('change',e=>{if((e.target.matches('variant-radios input[type="radio"]')&&isSizeName(e.target.name))||e.target.matches('variant-selects select')){const form=e.target.closest('section')?.querySelector('form[data-type="add-to-cart-form"]');form?.querySelector('.hm-select-size-message')?.remove();}},true);
  document.addEventListener('submit',e=>{const form=e.target;if(!form.matches('form[data-type="add-to-cart-form"]'))return;const scope=form.closest('section')||document;if(!selected(scope)){e.preventDefault();e.stopImmediatePropagation();showMessage(form);}},true);
  const mo=new MutationObserver(ms=>ms.forEach(m=>m.addedNodes.forEach(n=>{if(n.nodeType===1)clearDefault(n);})));
  mo.observe(document.documentElement,{childList:true,subtree:true});
})();